import type { createBrowserRouter, NavigateOptions, To } from 'react-router';

type AppRouter = ReturnType<typeof createBrowserRouter>;

let router: AppRouter | undefined;

export const setAppRouter = (nextRouter: AppRouter | undefined) => {
  router = nextRouter;
};

export const getRouterLocation = () => router?.state.location ?? window.location;

export const navigate = (to: To, options?: NavigateOptions) => {
  if (!router) throw new Error('The application router has not been initialized');
  return router.navigate(to, options);
};
